<script setup>
import { Fancybox } from "@fancyapps/ui/dist/fancybox.esm.js";
import { onMounted, ref, toRefs, watch } from "vue";

import { useState } from "../hooks/useState";

const props = defineProps({
  modelValue: Boolean,
  options: {
    type: Object,
    default: {}
  }
})

const emit = defineEmits(['update:modelValue']);

const { options, modelValue: opened } = toRefs(props)

const [instance, setInstance] = useState()

const $content = ref()

watch(opened, (opened) => {
  if (opened) {
    show()
  } else {
    close()
  }

})

onMounted(() => {
  if (opened.value) {
    show()
  }
})

function show() {
  const inst = Fancybox.show([{ src: $content.value, type: "html", ...options.value }], options.value)
  inst.on('destroy', () => {
    emit('update:modelValue', false)
  })
  setInstance(inst)
}

function close() {
  if (instance.value) {
    instance.value.close()
  }
}
</script>

<template>
  <div ref="$content" style="display: none;">
    <slot v-if="opened" :close="close"></slot>
  </div>

</template>

<style>
</style>